import App from 'app/app.js';
import 'app/store/ContentStore.js';

function LtPortraitPictureDayIdInputCtrl(
  $rootScope,
  $scope,
  $element,
  $window,
  $timeout,
  $filter,
  ContentStore,
  PortraitIdFormatterService,
  MessageStore
) {
  this.strictValidation = false;
  this.errorState = false;
  this.touched = false;
  this.focused = false;
  this.lifetouchCode = '';

  this.placeholderCodes = [
    ContentStore.getContent('MOBILE_TRANS_HOME_CENTER', ContentStore.appendCountryCode('PLACEHOLDER_PDID')),
    ContentStore.getContent('MOBILE_TRANS_HOME_CENTER', ContentStore.appendCountryCode('PLACEHOLDER_PID'))
  ];
  this.placeholderTypingSpeed = 400;
  this.placeholderSwitchDelay = 300;
  this.placeholderPrefix = ContentStore.getContent(
    'MOBILE_TRANS_HOME_CENTER',
    ContentStore.appendCountryCode('SEARCH_BY')
  );

  this.placeholderAnimTimer = null;
  this.placeholderCurrentCodeIndex = -1;
  this.placeholderCurrentCharIndex = -1;
  this.inputElement = $element[0].querySelector('input');

  this.init = function () {
    this.lifetouchCode = $scope.lifetouchCode;
    this.startPlaceholderAnim();
  };

  this.updatePlaceholderPrefix = function () {
    this.placeholderPrefix = ContentStore.getContent(
      'MOBILE_TRANS_HOME_CENTER',
      ContentStore.appendCountryCode('SEARCH_BY')
    );
    this.startPlaceholderAnim();
  };

  this.startPlaceholderAnim = function () {
    this.stopPlaceholderAnim();
    this.startNextCode();
  };

  this.stopPlaceholderAnim = function () {
    clearTimeout(this.placeholderAnimTimer);
    this.placeholderAnimTimer = null;
    this.placeholderCurrentCharIndex = -1;
    this.placeholderCurrentCodeIndex = -1;
    this.inputElement.placeholder = '';
  };

  this.startNextCode = function () {
    this.placeholderCurrentCharIndex = 0;
    this.placeholderCurrentCodeIndex = (this.placeholderCurrentCodeIndex + 1) % this.placeholderCodes.length;
    this.inputElement.placeholder = this.placeholderPrefix + ' ';

    this.typeNextChar();
  }.bind(this);

  this.typeNextChar = function () {
    var currentPlaceholderCode = this.placeholderCodes[this.placeholderCurrentCodeIndex];

    this.inputElement.placeholder += currentPlaceholderCode.charAt(this.placeholderCurrentCharIndex++);

    if (this.placeholderCurrentCharIndex < currentPlaceholderCode.length) {
      this.placeholderAnimTimer = setTimeout(this.typeNextChar, this.placeholderTypingSpeed);
    } else {
      this.placeholderAnimTimer = setTimeout(this.startNextCode, this.placeholderSwitchDelay);
    }
  }.bind(this);

  this.onInputFocus = function () {
    this.touched = true;
    this.focused = true;
    this.stopPlaceholderAnim();
  };

  this.onInputBlur = function () {
    this.focused = false;
    this.errorState = !this.isLifetouchCodeValid();
    this.startPlaceholderAnim();
  };

  this.onChangeLifetouchCodeHyphenCheck = () => {
    const input = this.lifetouchCode?.toUpperCase() || '';

    this.lifetouchCode = PortraitIdFormatterService.format(input);
  };

  this.callbackChange = function () {
    this.errorState = false;
    this.onChangeLifetouchCodeHyphenCheck();
    $scope.lifetouchCode = this.lifetouchCode;
    $scope.onChange();
  };

  this.shouldDisplayErrorState = () => this.errorState && (!$window.optimizeprepic || this.strictValidation);

  this.shouldDisplayErrorMessage = () =>
    $window.optimizeprepic &&
    this.errorState &&
    this.strictValidation &&
    !PortraitIdFormatterService.isFormattedPortraitId(this.lifetouchCode);

  this.getErrorMessage = () => {
    if (!this.isLifetouchCodeValid()) {
      const key = ContentStore.appendCountryCode('PICTURE_DAY_FORM_ERROR_MESSAGE');

      return $filter('ltTranslateFilter')(key);
    }

    return MessageStore.getSystemMessages()[0]?.message;
  };

  this.isLifetouchCodeValid = () => PortraitIdFormatterService.validate(this.lifetouchCode);

  this.isFloatingLabel = () => Boolean(this.lifetouchCode) || this.focused || (!$window.optimizeprepic && this.touched);

  this.isRequiredField = () => !Boolean($window.optimizeprepic);

  this.focus = () =>
    $timeout(() => {
      document.getElementById($scope.ltId)?.focus();
    });

  $scope.$on('jobLoadFlagUpdated', (event, data) => {
    this.strictValidation = data;
    this.errorState = data;
    this.focus();
  });

  $scope.$on('updatePortraitId', (event, lifetouchCode) => {
    this.lifetouchCode = lifetouchCode;
    $scope.lifetouchCode = lifetouchCode;
  });

  $scope.$on(
    'contentChanged',
    function () {
      this.updatePlaceholderPrefix();
    }.bind(this)
  );

  $scope.$on(
    '$destroy',
    function () {
      this.stopPlaceholderAnim();
    }.bind(this)
  );
}

App.controller('LtPortraitPictureDayIdInputCtrl', [
  '$rootScope',
  '$scope',
  '$element',
  '$window',
  '$timeout',
  '$filter',
  'ContentStore',
  'PortraitIdFormatterService',
  'MessageStore',
  LtPortraitPictureDayIdInputCtrl
]);
